import { render, staticRenderFns } from "./EqifyRuleHorseRegisteredToStudbook.vue?vue&type=template&id=742d422a&scoped=true"
import script from "./EqifyRuleHorseRegisteredToStudbook.vue?vue&type=script&lang=ts"
export * from "./EqifyRuleHorseRegisteredToStudbook.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742d422a",
  null
  
)

export default component.exports